import { DataStorage } from '@studyportals/data-storage';
import { PortalType } from '@studyportals/domain-client';

export class Experiment {
	public static isExperimentVariation(variationNumber: number, experimentName: string, portals: PortalType[]): boolean {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
		const experiment = DataStorage.retrieve(`Experiment/${experimentName}`);

		let currentPortalType = window.PortalType;
		if (currentPortalType === undefined && window.location.hostname === 'localhost') {
			currentPortalType = PortalType.MASTER;
		}

		if (!experiment || experiment === '' || !portals.includes(currentPortalType)) {
			return false;
		}

		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		return experiment.number === variationNumber;
	}
}
